var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _circle, _rect89, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableOnMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 450,
    viewBox: "0 0 800 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#1D2529"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    width: 50,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 24,
    width: 50,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 65,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 65,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 311,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 311,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 106,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 106,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 352,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 352,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 393,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 393,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 434,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 434,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 147,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 147,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 188,
    width: 35,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 188,
    width: 35,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 229,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 229,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 270,
    width: 52,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 270,
    width: 52,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 188,
    width: 50,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 623,
    y: 188,
    width: 50,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 147,
    width: 82,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 147,
    width: 82,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 229,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 229,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 229,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 229,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 24,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 24,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 65,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 65,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 270,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 270,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 270,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 270,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 65,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 65,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 434,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 434,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 106,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 106,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 24,
    width: 120,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 24,
    width: 120,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 147,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 147,
    width: 73,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 188,
    width: 120,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 188,
    width: 120,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 311,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 311,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 311,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 311,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 352,
    width: 35,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 638,
    y: 352,
    width: 35,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 106,
    width: 57,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 106,
    width: 57,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 393,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 393,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 352,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 352,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 434,
    width: 52,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 621,
    y: 434,
    width: 52,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 393,
    width: 85,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 393,
    width: 85,
    height: 17,
    rx: 6,
    fill: "#3C474D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 72,
    width: 174,
    height: 306,
    rx: 8,
    fill: "#EEF0F0",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 65,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 311,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 106,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 352,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 147,
    width: 78,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 188,
    width: 35,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 229,
    width: 62,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 270,
    width: 52,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 147,
    width: 82,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 229,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 65,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 270,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 188,
    width: 120,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 311,
    width: 128,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 106,
    width: 57,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 352,
    width: 102,
    height: 17,
    rx: 6,
    fill: "#EEF0F0"
  }))), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 344,
    width: 174,
    height: 35,
    fill: "white"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 72,
    width: 174,
    height: 38,
    fill: "white"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 94,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#D5D8DA"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 356,
    width: 48,
    height: 10,
    rx: 3,
    fill: "#D5D8DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 84,
    r: 4,
    fill: "#D5D8DA"
  }))), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 73,
    width: 172,
    height: 304,
    rx: 7,
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd",
    x: 259,
    y: 27,
    width: 282,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 72,
    width: 174,
    height: 306,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableOnMobile);
export default __webpack_public_path__ + "static/media/table-on-mobile.591836e0b9539f971deff0080fb20a2d.svg";
export { ForwardRef as ReactComponent };